module.exports = __webpack_public_path__ + "img/025-nurse.8087d49a.png";